import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogData } from 'src/app/types/infrastructure/interfaces/IDialogData';

@Component({
  selector: 'app-dialog',
  // standalone: true,
  // imports: [],
  templateUrl: './dialog.component.html',
  styleUrl: './dialog.component.css'
})
export class DialogComponent {


  readonly dialogRef = inject(MatDialogRef<DialogComponent>);
  readonly data = inject<DialogData>(MAT_DIALOG_DATA);



  button_cancel_clicked() {
    this.dialogRef.close(false);
  }
  button_ok_clicked() {
    this.dialogRef.close(true);
  }
}
